import { useDispatch, useSelector } from "react-redux"
import ContainerLayout from "../components/admission/containerlayout"
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/banner/banner"
import EnergyEconomic from "../components/research/energyEconomic"
import Info from "../components/research/info"
import Institutes from "../components/research/institutes"
import Press from "../components/research/press"
import RAndD from "../components/research/rAndD"
import Renewable from "../components/research/renewable"
import SmartCity from "../components/research/smartCity"
import { useEffect } from "react"
import { fetchResearchData } from "../redux/slice/researchPage"
import { retrunAssets } from "../utils/getAssets"
import { DecodeHtml } from "../utils/decodeHtml"

const Research = () => {


    const state = useSelector(state => state.research)
    const dispatch = useDispatch()

    useEffect(() => {
        if (state?.data == null) {
            dispatch(fetchResearchData("research"))
        }
    }, [state, dispatch])


    const research = state?.data?.properties


    const text = research?.title
    const bg = research?.backgroundImage != null ? retrunAssets(research?.backgroundImage[0]?.url) : ""

    const header = research?.header2
    const description = DecodeHtml({ html: research?.description2?.markup })

    const researchSection = research?.researchSection?.items?.map(item => {
        item = item?.content?.properties
        return {
            title: item?.title,
            description: item?.description,
            thumbnailImage: item?.thumbnailImage != null ? retrunAssets(item?.thumbnailImage[0]?.url) : '',
            thumbnailYoutubeURL: item?.thumbnailYoutubeURL,
            pagesPath: item?.pagesPath?.map(path => {
                return {
                    name: path?.name,
                    link: path?.route?.path
                }
            }),
            externalLinks: item?.externalLinks?.items?.map(link => {
                link = link?.content?.properties
                return {
                    name: link?.label,
                    link: link?.link,
                }
            })
        }
    })

    const quote = research?.header1





    return (
        <AnimatedPage>
            <Banner text={text} bg={bg} />
            <ContainerLayout>
                <div className="grid gap-24 my-16">
                    <div className="grid place-items-center p-12 bg-[#3E4A6A] text-white font-bold">
                        <h1 className="text-center text-[2rem] lg:text-[3rem]">{quote}</h1>
                    </div>
                    <div className="grid lg:px-24">
                        <Info research={research} />
                    </div>
                    <div className="grid gap-5 place-items-center text-center">
                        <h1 className="text-center text-[2rem] lg:text-[3rem] font-bold">{header}</h1>
                        {description}
                    </div>
                    {
                        researchSection?.map((section,index) => {
                            return (
                                <Institutes key={index} reverse={index % 2 !== 0} data={section} />
                            )
                        })
                    }
                    {/* <RAndD />
                    <Renewable />
                    <EnergyEconomic />
                    <Press />
                    <SmartCity /> */}
                </div>
            </ContainerLayout>

        </AnimatedPage>
    )
}

export default Research